(function(){
  if (window.__qswBound) return; window.__qswBound = true;
  function q(card, sel){ return card.querySelector(sel); }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.qsw__item'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var card = b.closest('[data-qsw-card]'); if (!card) return;
    var wrap = b.closest('.qsw');
    wrap.querySelectorAll('.qsw__item').forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-checked','false'); });
    b.classList.add('is-active'); b.setAttribute('aria-checked','true');

    var img = q(card, '[class*="__image-slot"] img');
    if (img && b.dataset.img) { img.src = b.dataset.img; if (b.dataset.srcset) img.srcset = b.dataset.srcset; }
    var price = q(card, '.qouven-collection-card__price, .qouven-featured-collection__price');
    if (price && b.dataset.price) price.textContent = b.dataset.price;
    var cmp = q(card, '.qouven-collection-card__compare, .qouven-featured-collection__compare');
    if (cmp) { cmp.textContent = b.dataset.compare || ''; cmp.style.display = b.dataset.compare ? '' : 'none'; }
    var badge = q(card, '.qouven-collection-card__badge, .qouven-featured-collection__badge:not(.qouven-featured-collection__badge--dark)');
    if (badge) { if (b.dataset.pct) { badge.textContent = '-' + b.dataset.pct + '%'; badge.style.display = ''; } else { badge.style.display = 'none'; } }
    if (b.dataset.url) card.querySelectorAll('a[href*="/products/"]').forEach(function(a){ if (!a.classList.contains('qsw__more')) a.href = b.dataset.url; });

    if (wrap.dataset.qswMode === 'variant') {
      var idInput = q(card, 'form input[name="id"]'); if (idInput) idInput.value = b.dataset.variantId;
      var ok = b.dataset.available === 'true';
      var btn = q(card, 'form button[type="submit"]');
      if (btn) {
        btn.disabled = !ok;
        var txt = btn.querySelector('[class*="__button-text"]') || btn;
        var add = btn.dataset.defaultText || (window.MinimogStrings && MinimogStrings.addToCart) || 'إضافة إلى السلة';
        var sold = (window.MinimogStrings && MinimogStrings.soldOut) || 'نفدت الكمية';
        if (txt !== btn || !btn.querySelector('span')) txt.textContent = ok ? add : sold;
      }
    }
  }, true);
})();
